module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('hr', {
    staticClass: "splitline"
  }), _vm._v(" "), _c('article', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(" " + _vm._s(_vm._f("timePretty")(_vm.article.date)) + "\n    / Updated on " + _vm._s(_vm._f("timePretty")(_vm.article.updated)) + "\n   ")]), _vm._v(" "), _c('hr', {
    staticClass: "splitline"
  }), _vm._v(" "), (_vm.article.comments && _vm.config && _vm.themeCfg.disqus_shortname) ? _c('only-disqus', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef4a6ce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleItem.vue
// module id = 164
// module chunks = 1